import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCall";

export const useAddress = (userRequest, enabled = true) => {
  const { params, data } = userRequest;
  const request = {
    method: "get",
    url: "address",
    params: params,
    data: data,
  };
  return useQuery({
    queryKey: ["address", params],
    enabled: enabled,
    queryFn: () => callApi(request),
  });
};
